// extracted by mini-css-extract-plugin
export default {"container":"Current_container__nXTIu","title":"Current_title__wYDHf","description":"Current_description__NZUgr","goals":"Current_goals__8nfQx"};